"use client";
import { type FormEventHandler, type PropsWithChildren } from "react";
import {
  type FieldValues,
  type SubmitErrorHandler,
  type SubmitHandler,
  type UseFormReturn,
} from "react-hook-form";
import { FormProvider } from "react-hook-form";

export interface FormProps<TFormValues extends FieldValues> {
  form: UseFormReturn<TFormValues>;
  onSubmit?: SubmitHandler<TFormValues>;
  onManualSubmit?: FormEventHandler<HTMLFormElement>;
  onError?: SubmitErrorHandler<TFormValues>;
}

export default function Form<TFormValues extends FieldValues>(
  props: PropsWithChildren<FormProps<TFormValues>>,
) {
  const { form, onSubmit, onManualSubmit, onError, children } = props;

  return (
    <FormProvider {...form}>
      <form
        noValidate
        autoComplete="off"
        onSubmit={
          onSubmit ? form.handleSubmit(onSubmit, onError) : onManualSubmit
        }
      >
        {children}
      </form>
    </FormProvider>
  );
}
